import { theme } from "antd";
import { ACTIVE_ACCENT_COLOR } from "./themeConstants";

const sharedToken = {
  colorPrimary: "#30EFD3",
  fontSize: 15,
  lineHeight: 1.6,
  borderRadius: 6,
  colorLink: "#30EFD3",
};

const sharedComponents = {
  Typography: {
    titleMarginTop: 0.9,
    titleMarginBottom: 0.6,
  },
  Button: {
    colorPrimary: ACTIVE_ACCENT_COLOR,
    colorPrimaryHover: "#144A47",
    colorPrimaryActive: "#0D2F2D",
    primaryColor: "#F3FAFC",
  },
};

const darkToken = {
  ...sharedToken,
  colorText: "#E6F0F2",
  colorTextSecondary: "#A5B3B8",
  colorTextTertiary: "#7D8A90",
  colorTextHeading: "#F3FAFC",
  colorTextLightSolid: "#F3FAFC",
  colorBgBase: "#000000",
  colorBgContainer: "#111417",
  colorBorderSecondary: "#1E2A2E",
  colorFillSecondary: "#0E1518",
};

const lightToken = {
  ...sharedToken,
  colorText: "#1A2328",
  colorTextSecondary: "#4A5A61",
  colorTextTertiary: "#6B7A82",
  colorTextHeading: "#0F1419",
  colorTextLightSolid: "#F3FAFC",
  colorBgBase: "#F5F7F8",
  colorBgContainer: "#FFFFFF",
  colorBorderSecondary: "#D8E0E3",
  colorFillSecondary: "#EEF2F4",
};

const darkComponents = {
  ...sharedComponents,
  Layout: {
    bodyBg: "#000000",
    headerBg: "#000000",
    siderBg: "#000000",
    footerBg: "#000000",
  },
  Card: {
    colorBgContainer: "#111417",
    headerBg: "#111417",
    bodyPadding: 20,
    headerFontSize: 16,
    headerHeight: 52,
    colorBorderSecondary: "#1E2A2E",
  },
  Progress: {
    defaultColor: "#30EFD3",
    remainingColor: "#27343A",
    circleTextColor: "#E6F0F2",
    lineBorderRadius: 999,
  },
  Menu: {
    darkItemBg: "#000000",
    darkItemColor: "#93A6AD",
    darkItemSelectedColor: "#D7FEF7",
    darkItemSelectedBg: ACTIVE_ACCENT_COLOR,
    darkItemHoverColor: "#E6F0F2",
    darkItemHoverBg: "#0F2124",
    itemBg: "#000000",
    itemColor: "#93A6AD",
    itemSelectedColor: "#D7FEF7",
    itemSelectedBg: ACTIVE_ACCENT_COLOR,
    itemHoverColor: "#E6F0F2",
    itemHoverBg: "#0F2124",
  },
};

const lightComponents = {
  ...sharedComponents,
  Layout: {
    bodyBg: "#F5F7F8",
    headerBg: "#FFFFFF",
    siderBg: "#FFFFFF",
    footerBg: "#F5F7F8",
  },
  Card: {
    colorBgContainer: "#FFFFFF",
    headerBg: "#FFFFFF",
    bodyPadding: 20,
    headerFontSize: 16,
    headerHeight: 52,
    colorBorderSecondary: "#D8E0E3",
  },
  Progress: {
    defaultColor: "#30EFD3",
    remainingColor: "#D8E0E3",
    circleTextColor: "#1A2328",
    lineBorderRadius: 999,
  },
  Menu: {
    itemBg: "#FFFFFF",
    itemColor: "#4A5A61",
    itemSelectedColor: "#0D2F2D",
    itemSelectedBg: "#D4F7F0",
    itemHoverColor: "#1A2328",
    itemHoverBg: "#EEF2F4",
  },
};

export function getAntTheme(isDark) {
  return {
    algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
    token: isDark ? darkToken : lightToken,
    components: isDark ? darkComponents : lightComponents,
  };
}
